import Common from '@/utils/common'

// 查询个人客户信息
export function getPersonalInfo(data) {
  return Common.createRequest('customer-api', 'CUSTOMER_017', data)
}
// 个人认证
export function personalAuth(data) {
  return Common.createRequest('customer-api', 'CUSTOMER_001', data, '个人认证')
}
// 查询企业客户信息
export function getCompanyInfo(data) {
  return Common.createRequest('customer-api', 'CUSTOMER_008', data)
}
// 企业认证
export function companyAuth(data) {
  return Common.createRequest('customer-api', 'CUSTOMER_002', data, '企业认证')
}
